module.exports = __webpack_public_path__ + "view/pointinfo.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]&outputPath=view/!./src/view/pointinfo.html
// module id = 28
// module chunks = 0